module.exports = __webpack_public_path__ + "img/expand-recommend.7bf24f31.svg";